// src/pages/JudgmentsPage.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../api";

function JudgmentsPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
  const [perfById, setPerfById] = useState({});
  const navigate = useNavigate();
  function money(n) {
    const v = Number(n || 0);
    return v.toLocaleString(undefined, { style: "currency", currency: "USD" });
  }

  useEffect(() => {
    async function load() {
      try {
    const data = await apiRequest("/judgments?limit=200");
    setRows(Array.isArray(data) ? data : []);

    // Load judgment performance (balance + days)
    const perf = await apiRequest("/reports/judgments/performance");
    const perfRows = Array.isArray(perf?.rows) ? perf.rows : [];
    const map = {};
    for (const r of perfRows) {
      map[r.judgment_id] = r;
    }
    setPerfById(map);

      } catch (e) {
        console.error("Failed to load judgments:", e);
        setErr(e.message);
      } finally {
        setLoading(false);
      }
    }
    load();
  }, []);

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
  };
  const thStyle = {
    textAlign: "left",
    borderBottom: "1px solid #ccc",
    padding: "8px",
    fontSize: "14px",
    background: "#f8f8f8",
  };
  const tdStyle = {
    borderBottom: "1px solid #eee",
    padding: "8px",
    fontSize: "14px",
    cursor: "pointer",
  };

  if (loading) {
    return <div>Loading judgments…</div>;
  }

  if (err) {
    return <div style={{ color: "red" }}>Error: {err}</div>;
  }

  return (
    <div>
      <div
  style={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    marginBottom: 12,
  }}
>
  <h2 style={{ margin: 0 }}>Judgments</h2>

  <button
    onClick={() => navigate("/judgments/new")}
    style={{
      padding: "8px 12px",
      border: "1px solid #1976d2",
      borderRadius: 8,
      background: "#1976d2",
      color: "#fff",
      cursor: "pointer",
      fontWeight: 700,
    }}
    title="Create a new judgment"
  >
    + New Judgment
  </button>
</div>


      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>Case #</th>
            <th style={thStyle}>Status</th>
            <th style={thStyle}>Principal</th>
            <th style={thStyle}>Judgment Date</th>
            <th style={thStyle}>Balance Due</th>
            <th style={thStyle}>Days Since Last Payment</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((j) => (
            <tr
              key={j.id}
              onClick={() => navigate(`/judgments/${j.id}`)}
              title="Open judgment"
            >
              <td style={tdStyle}>{j.case_number || "-"}</td>
              <td style={tdStyle}>{j.status || "-"}</td>
              <td style={tdStyle}>
                {j.principal !== undefined
                  ? `$${Number(j.principal).toFixed(2)}`
                  : "-"}
              </td>
              <td style={tdStyle}>{j.judgment_date || "-"}</td>
              <td style={tdStyle}>
                {perfById[j.id]?.current_balance_due != null ? money(perfById[j.id].current_balance_due) : "—"}
              </td>
              <td style={tdStyle}>
                {perfById[j.id]?.days_since_last_payment ?? "—"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div style={{ fontSize: 12, color: "#777", marginTop: 10 }}>
        Tip: click a row to view parties, notes, balance, transactions, and add activity notes.
      </div>
    </div>
  );
}

export default JudgmentsPage;
